import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import AppointmentFormPage from "./pages/appointment-form-page";
import AppointmentPage from "./pages/appointment-page/AppointmentPage";
import SuccessFulSubmission from "./pages/successful-submission/SuccessFulSubmission";

function App() {
  return (
    <>
      <Router>
        <Routes>
          <Route path="/" element={<AppointmentFormPage />} />
          {/* <Route path="/" element={<AppointmentPage />} /> */}
          {/* <Route path="/appointment" element={<AppointmentFormPage />} /> */}
          <Route
            path="/successful-submission"
            element={<SuccessFulSubmission />}
          />
        </Routes>
      </Router>
      <ToastContainer />
    </>
  );
}

export default App;
